const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];
const SUPPORTED_FORMATS_PDF = ["application/pdf"];

const JobRole = {
  individualContributor: "1",
  management: "2",
};

const modifiers = {
  plus: "+",
  minus: "-",
  equal: "=",
};

const COLUMNS = [
  "Level of Work & Modifier",
  "Institutional Expertise & Skill",
  "Cultural Impact",
  "Physical Environment",
  "Mental & Emotional Environment",
  "Application of Knowledge & Skill",
  "Manual Effort",
  "Outcomes",
];

export {
  SUPPORTED_FORMATS,
  JobRole,
  modifiers,
  COLUMNS,
  SUPPORTED_FORMATS_PDF,
};
